import { render, staticRenderFns } from "./ButtonSelectSimple.vue?vue&type=template&id=fef7c0b2&"
import script from "./ButtonSelectSimple.vue?vue&type=script&lang=ts&"
export * from "./ButtonSelectSimple.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonSelectSimple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports